import { RootState, useAppDispatch } from "@services/Redux";
import * as React from "react";
import { useSelector } from "react-redux";
import Styled from "./styled";
import { BiShoppingBag } from "react-icons/bi";
import { Money } from "@utils/currency";
import { ControlledMenu, useMenuState } from "@szhsin/react-menu";
import PulseLoader from "react-spinners/PulseLoader";
import "./index.css";
import { toggleAddProductToOrderSuccess } from "@services/Redux/order";
import ReactGA from "react-ga4";
import { useNavigate } from "react-router";
import MetaPixel from "@utils/meta/MetaPixel";

const TopbarOrderButton: React.FC = () => {
  const order = useSelector((state: RootState) => state.order);
  const value = order.data?.value ?? 0;
  const [menuProps, toggleMenu] = useMenuState({ transition: true });
  const ref = React.createRef<HTMLDivElement>();
  const dispatch = useAppDispatch();
  const dismissTooltipTimeout = React.useRef<NodeJS.Timeout>();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (order.addProductToOrderSuccess && (menuProps.state === "closed" || !menuProps.state)) {
      toggleMenu(true);
      dispatch(toggleAddProductToOrderSuccess(false));
      dismissTooltipTimeout.current = setTimeout(() => {
        toggleMenu(false);
      }, 4000);
    }
  }, [order.addProductToOrderSuccess, dispatch, menuProps, toggleMenu]);

  React.useEffect(() => {
    // Clearing timeout to avoind state change when unmounted
    return () => {
      if (dismissTooltipTimeout.current) {
        clearTimeout(dismissTooltipTimeout.current);
      }
    };
  }, []);

  const openCart = () => {
    navigate("/sacola");
    if (order.data) {
      const source = localStorage.getItem("source");

      ReactGA.gtag("event", "view_cart", {
        currency: "BRL",
        shipping: order.data.shipment_value ?? 0,
        value: order.data.value,
        affiliation: source,
        items: order.data.items.map((item) => ({
          item_id: item.product.id,
          item_name: item.product.name,
          price: item.price,
          quantity: item.quantity,
          item_category: item.product.categories?.[0].name,
          item_variant: `${item.variation?.color?.name}`,
          size: item.variation?.size?.name,
        })),
      });
      MetaPixel.trackCustom("view_cart", {
        currency: "BRL",
        shipping: order.data.shipment_value ?? 0,
        value: order.data.value,
        affiliation: source,
        items: order.data.items.map((item) => ({
          item_id: item.product.id,
          item_name: item.product.name,
          price: item.price,
          quantity: item.quantity,
          item_category: item.product.categories?.[0].name,
          item_variant: `${item.variation?.color?.name}`,
          size: item.variation?.size?.name,
        })),
      });
    }
  };

  return (
    <div>
      <Styled.RootContainer ref={ref} onClick={openCart}>
        <BiShoppingBag size={20} className="me-1" />
        {order.loadingOrder && <PulseLoader color="white" size={8} />}
        {!order.loadingOrder && <span>{order.data?.id ? Money(value).format() : "sem produtos"}</span>}
      </Styled.RootContainer>
      <ControlledMenu
        {...menuProps}
        anchorRef={ref}
        arrow={true}
        className="order-tooltip"
        menuStyle={{ backgroundColor: "#2BBA61", color: "white" }}
        arrowStyle={{ backgroundColor: "#2BBA61" }}
      >
        <span className={"px-3"}>Os produtos foram colocados na sacola</span>
      </ControlledMenu>
    </div>
  );
};

export default TopbarOrderButton;
